module.exports = __webpack_public_path__ + "static/media/prequal_history.ee54d7c8.svg";